"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextProvider = void 0;
var React = __importStar(require("react"));
var DayPickerContext_1 = require("./DayPickerContext");
var FocusContext_1 = require("./FocusContext");
var NavigationContext_1 = require("./NavigationContext");
var SelectMultipleContext_1 = require("./SelectMultipleContext");
var SelectRangeContext_1 = require("./SelectRangeContext");
var SelectSingleContext_1 = require("./SelectSingleContext");
/** Provide the value for all the context providers. */
function ContextProvider(props) {
    var children = props.children, initialProps = __rest(props, ["children"]);
    return (React.createElement(DayPickerContext_1.DayPickerProvider, { initialProps: initialProps },
        React.createElement(NavigationContext_1.NavigationProvider, null,
            React.createElement(SelectRangeContext_1.SelectRangeProvider, { initialProps: initialProps },
                React.createElement(SelectMultipleContext_1.SelectMultipleProvider, { initialProps: initialProps },
                    React.createElement(SelectSingleContext_1.SelectSingleProvider, { initialProps: initialProps },
                        React.createElement(FocusContext_1.FocusProvider, null, children)))))));
}
exports.ContextProvider = ContextProvider;
//# sourceMappingURL=ContextProvider.js.map